import { defineStore } from 'pinia'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'

export const useBusinessSwitchStore = defineStore('businessSwitch', () => {
  const borrowerStore = useBorrowerStore()
  const router = useRouter()
  const rootStore = useRootStore()

  /*
    ███████ ████████  █████  ████████ ███████
    ██         ██    ██   ██    ██    ██
    ███████    ██    ███████    ██    █████
         ██    ██    ██   ██    ██    ██
    ███████    ██    ██   ██    ██    ███████
    STATE
  */

  const switching = ref(false)
  const selected = ref(false)
  let _switchTimer = null

  /*
     █████   ██████ ████████ ██  ██████  ███    ██ ███████
    ██   ██ ██         ██    ██ ██    ██ ████   ██ ██
    ███████ ██         ██    ██ ██    ██ ██ ██  ██ ███████
    ██   ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
    ██   ██  ██████    ██    ██  ██████  ██   ████ ███████
    ACTIONS
    ! - - Actions calling other actions in the same store must use `this.actionName(...)`
    ! - - If we do not use `this.actionName` it will not be properly mockable in tests.
    ! - - Computeds and refs will work fine, and should be called directly though.
  */

  async function switchTo(borrower, loadingDelay = 1000) {
    if (borrower.id === borrowerStore.borrowerId || !rootStore.authUser?.borrowers?.some(b => b.id === borrower.id)) {
      return
    }

    clearTimeout(_switchTimer)
    const isSwitch = !!borrowerStore.borrowerId
    switching.value = isSwitch;
    selected.value = borrower;
    await borrowerStore.getBorrower({ borrowerId: borrower.id, forceReload: true, touch: true })
    await router.push(rootStore.getRedirectUrl())
    if (isSwitch) {
      _switchTimer = setTimeout(() => {
        selected.value = null
        switching.value = false
      }, loadingDelay)
    } else {
      selected.value = null
    }
  }

  return {
    //STATE
    selected,
    switching,
    //ACTIONS
    switchTo,
  }
})
